// Module
var code = "<svg width=\"18\" height=\"15\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M14.76 5.829V1.607h-2.52v1.671L9 0 0 9.107h2.16V15h5.58v-4.821h2.52V15h5.58V9.107H18z\"/></svg>";
// Exports
export default code;